'use client';

import { useEffect } from 'react';
import { Button } from "@/components/base/buttons/button";
import Image from 'next/image';
import errorImage from '@/assets/500.webp';

export default function Error({ error, reset }) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
    }, [error]);

    return (
        <div className="min-h-screen w-full bg-white flex items-center justify-center p-6 md:p-12">
            <div className="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                {/* Text Column */}
                <div className="flex flex-col items-center lg:items-start text-center lg:text-left order-1 lg:order-1 space-y-6">
                    <span className="text-md font-semibold tracking-widest text-brand-600 uppercase">
                        Error 500
                    </span>

                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 leading-[1.1]">
                        Something went up in <span className="text-brand-600 italic">smoke.</span>
                    </h1>

                    <p className="text-lg text-gray-600 max-w-md leading-relaxed">
                        Our servers seem to have overheated. We're dousing the flames and restoring order as we speak.
                    </p>

                    <div className="pt-4 flex flex-col sm:flex-row gap-4">
                        <Button
                            onClick={() => reset()}
                            color="primary"
                            size="xl"
                        >
                            Try again
                        </Button>
                        <Button
                            href="/"
                            color="secondary"
                            size="xl"
                        >
                            Return Home
                        </Button>
                    </div>
                </div>
                {/* Illustration Column */}
                <div className="flex justify-center lg:justify-end order-2 lg:order-2">
                    <div className="relative w-full max-w-[500px] aspect-square">
                        <Image
                            src={errorImage}
                            alt="500 Error Illustration - Burnt papers and smoke"
                            fill
                            className="object-contain"
                            priority
                        />
                    </div>
                </div>


            </div>
        </div>
    );
}
